// 将扁平数组转换为树形结构, 同级需要根据orderMap排序(升序)
export const buildTree = (flatData, orderMap) => {
  if (!Array.isArray(flatData) || flatData.length === 0) return [];

  const map = new Map();
  const roots = [];

  flatData.forEach((item) => {
    const path = `/product/all-skus?productCatalogueItemId=${item.id}`;
    const p = item.redirectUrl ? item.redirectUrl : !item.children?.length ? path : undefined;
    map.set(item.id, {
      ...item,
      key: item.id,
      title: item.name,
      path: p,
      index: orderMap?.[item.id] || 0,
      children: [],
      label: item.name,
      value: item.id,
    });
  });

  flatData.forEach((item) => {
    const node = map.get(item.id);
    if (!item.parentId) {
      roots.push(node);
    } else {
      const parent = map.get(item.parentId);
      parent && parent.children.push(node);
    }
  });

  flatData.forEach((item) => {
    const node = map.get(item.id);
    if (node.children.length > 0) {
      node.children.sort((a, b) => a.index - b.index);
    }
  });

  return roots.sort((a, b) => a.index - b.index);
};

// 查找节点
export const findNode = (data, key) => {
  if (!Array.isArray(data) || data?.length === 0) return {};
  for (const item of data) {
    if (item.id === key) {
      return item;
    }
  }
  return {} as any;
};

// 获取所有可展开节点的 key
export const findExpandableKeys = (data, keys = []) => {
  data.forEach((item) => {
    if (item.children?.length > 0) {
      keys.push(item.id);
      findExpandableKeys(item.children, keys);
    }
  });
  return Array.from(new Set(keys));
};

// 构建级联选择器选项, 只有type<2的目录可以作为父级目录, 且不能有跳转路径
export const buildCascaderOptions = (data, type = 1) => {
  if (type > 2 || !Array.isArray(data) || data?.length === 0) return [];
  const arr = data?.filter((item) => item.type === type && !item.redirectUrl);
  return arr.map((item) => ({
    label: item.name,
    value: item.id,
    children: item.children?.length ? buildCascaderOptions(item.children, 2) : undefined,
  }));
};

// 在树中查找节点
export const findNodeInTree = (tree, nodeId) => {
  for (const node of tree) {
    if (node.id === nodeId) {
      return node;
    }
    if (node.children?.length) {
      const found = findNodeInTree(node.children, nodeId);
      if (found) return found;
    }
  }
  return null;
};

// 检查节点是否是另一个节点的子节点（防止循环引用）
export const isDescendant = (parentId, childId, tree) => {
  if (parentId === childId) return true;
  const parent = findNodeInTree(tree, parentId);
  if (!parent || !parent.children?.length) return false;
  for (const child of parent.children) {
    if (child.id === childId || isDescendant(child.id, childId, tree)) {
      return true;
    }
  }
  return false;
};

// 从树中移除节点
export const removeNodeFromTree = (tree, nodeId) => {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].id === nodeId) {
      return tree.splice(i, 1)[0];
    }
    if (tree[i].children?.length) {
      const removed = removeNodeFromTree(tree[i].children, nodeId);
      if (removed) return removed;
    }
  }
  return null;
};

// 在树中查找节点并插入
export const insertNodeToTree = (tree, targetId, newNode, dropPosition) => {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].id === targetId) {
      if (dropPosition === 0) {
        // 作为子节点
        if (!tree[i].children) {
          tree[i].children = [];
        }
        tree[i].children.push(newNode);
      } else if (dropPosition === -1) {
        // 在目标节点之前
        tree.splice(i, 0, newNode);
      } else if (dropPosition === 1) {
        // 在目标节点之后
        tree.splice(i + 1, 0, newNode);
      }
      return true;
    }
    if (tree[i].children?.length) {
      if (insertNodeToTree(tree[i].children, targetId, newNode, dropPosition)) {
        return true;
      }
    }
  }
  return false;
};

// 更新树中所有节点的 parentId
export const updateParentIds = (tree, parentId = null) => {
  tree.forEach((node) => {
    node.parentId = parentId;
    if (node.children?.length) {
      updateParentIds(node.children, node.id);
    }
  });
};

export const getOrderMapAndChangePidsData = (treeData) => {
  const changePidsData = []; // 父级id变更的数据
  const orderMap = {};
  const traverseTreeData = (data) => {
    if (!Array.isArray(data) || data?.length === 0) return;
    data.forEach((item, index) => {
      orderMap[item.id] = index;
      const originalItem = treeData.find((i) => i.id === item.id);
      const originalParentId = originalItem?.parentId || undefined;
      const currentParentId = item.parentId || undefined;
      if (originalParentId !== currentParentId) {
        changePidsData.push({ id: item.id, parentId: currentParentId });
      }
      if (item.children?.length) {
        traverseTreeData(item.children);
      }
    });
  };
  traverseTreeData(treeData);
  return { orderMap, changePidsData };
};
